import { render } from "./CompanyLayout.vue?vue&type=template&id=383b2ffd&scoped=true"
import script from "./CompanyLayout.vue?vue&type=script&lang=js"
export * from "./CompanyLayout.vue?vue&type=script&lang=js"

import "./CompanyLayout.vue?vue&type=style&index=0&id=383b2ffd&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383b2ffd"]])

export default __exports__